import { LitElement } from 'lit';
import { customElement, query } from 'lit/decorators.js';
@customElement('kin-password-toggle')
export class PasswordToggleComponent extends LitElement {
  active: boolean = false;
  @query('[data-pw-toggle-input]') toggleInput!: HTMLElement;
  @query('[data-pw-toggle-trigger]') toggleTrigger!: HTMLElement;

  createRenderRoot() {
    return this;
  }

  async firstUpdated() {
    await new Promise((resolve) => setTimeout(resolve, 0));
    this.toggleTrigger.addEventListener('click', (e: Event) => this.handleClick(e));
  }

  disconnectedCallback() {
    if (this.toggleTrigger) {
      this.toggleTrigger.removeEventListener('click', (e: Event) => this.handleClick(e));
    }
    super.disconnectedCallback();
  }

  handleClick(e: Event) {
    e.preventDefault();
    this.toggle();
  }

  toggle() {
    return this.active ? this.hidePassword() : this.showPassword();
  }

  showPassword() {
    this.active = true;
    this.toggleTrigger.classList.add('active');
    this.toggleInput.setAttribute('type', 'text');
  }

  hidePassword() {
    this.active = false;
    this.toggleTrigger.classList.remove('active');
    this.toggleInput.setAttribute('type', 'password');
  }
}
